import { AnyAction } from "redux";

import { carsActions } from "../reducer";

export const resetCarEBoxDashboardData = (): AnyAction =>
  carsActions.resetEBoxDashboardData();
